import { createSlice } from '@reduxjs/toolkit';

const header = createSlice({
  name: 'header',
  initialState: {
    headerTitle: '',
    selectedMenuItemId: 1,
  },
  reducers: {
    setHeaderTitle : (state, action) => {
        state.headerTitle = action.payload;
    },
    setSideBarMenuItemId : (state, action) => {
      state.selectedMenuItemId = action.payload;
    },
  },
  
});

export const { setHeaderTitle, setSideBarMenuItemId } = header.actions;
export default header.reducer;